import Vue from "vue";
import store from "./vuex/store";
// import $ from "./jquery";

export const getResources = ({ dispatch }, lang, reload) => {
  Vue.http.get("api/v1/Resources?culture=" + lang).then(function (response) {
    dispatch("LANGUAGE_LOADED", lang, response.data);
    if (reload) {
      document.location.reload();
    }
  });
};

export const scrollChanged = ({ dispatch }) => {
  var position = window.pageYOffset;

  if (!store.state.scrolled && position > 10) {
    dispatch("SCROLLED", true);
  } else if (store.state.scrolled && position < 10) {
    dispatch("SCROLLED", false);
  }
};

export const checkLogged = ({ dispatch }) => {
  if (window.localStorage.getItem("access_token")) {
    dispatch("LOGGED_IN", window.localStorage.getItem("access_token"));
    var queryHash = getParameterByName("hash");
    if (queryHash !== null) {
      var newUrl = window.location.href.split("?")[0];
      var params = window.location.href.split("#");
      if (params.length > 1) {
        window.location = newUrl + "#" + params[1];
      } else {
        window.location = newUrl;
      }
    }
  } else {
    var hash = getParameterByName("hash");
    if (hash == null) {
      window.localStorage.setItem("returnUrl", window.location.href);
      document.location = Vue.http.options.profilerUrl + "/services/sso.aspx?ret=" + window.location.href;
    } else {
      console.log("there is hash: " + hash);
      var currentUser = {
        username: hash,
        password: "",
        grant_type: "password",
        company: ""
      };
      Vue.http.post(Vue.http.options.root + "/api/Token", currentUser).then(function (response) {
        dispatch("LOGGED_IN", response.data.access_token);
        var newUrl = window.location.href.split("?")[0];
        var params = window.location.href.split("#");
        if (params.length > 1) {
          window.location = newUrl + "#" + params[1];
        } else {
          window.location = newUrl;
        }
      }, function (response) {
      });
    }
  }
};

export const setCulture = ({ dispatch }) => {
  if (window.localStorage.getItem("current_culture")) {
    dispatch("SET_CULTURE", window.localStorage.getItem("current_culture"));
  }
};

export const logout = ({ dispatch }) => {
  Vue.http.get("api/v1/Users/Logout").then(function (response) {
    dispatch("LOG_OUT", response.data);
  });
};

function getParameterByName (name, url) {
  if (!url) url = window.location.href;
  name = name.replace(/[\[\]]/g, "\\$&");
  var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)");
  var results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return "";
  return decodeURIComponent(results[2].replace(/\+/g, " "));
}



// WEBPACK FOOTER //
// ./src/AppActions.js